module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1122.a920f23d.png";